import styled from 'styled-components';

export const SocialLinksList = styled.ul`
  display: flex;
`;

export const SocialLinksItem = styled.li`
  display: block;
  margin-right: 1rem;
`;

export const SocialLinksLink = styled.a`
  display: block;
  width: 50px;
  color: var(--primary-color);
`;
